const FromArrEditor = [{
		key: 'parentID',
		modelvalue: undefined,
		title: "上级类型：",
		inputtype: "cascader",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 0,
		marginTop: 8,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		props: {
			label: 'CostName',
			value: 'CSMID',
			children: 'ChildsList',
			checkStrictly: true
		}
	}, {
		key: 'nodeType',
		modelvalue: undefined,
		title: "节点类型：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 40,
		marginTop: 8,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	},
	{
		key: 'costName',
		title: "类型名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 80,
		marginTop: 0,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		key: 'remark',
		title: "类型备注：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 198,
		height: 32,
		disabled: false,
		marginLeft: 0,
		marginTop: 18,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		key: 'costType',
		title: "价格形式：",
		inputtype: "radio",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 198,
		height: 32,
		disabled: false,
		marginLeft: 40,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 500,
		modelvalue: 0,
		options: []
	},
	{
		key: 'priorityLevel',
		title: "优先级：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 222,
		height: 32,
		disabled: false,
		marginLeft: 32,
		marginTop: 24,
		displayVal: "inline-block",
		fontWeightVal: 500,
		modelValue: 0,
	},
	{
		key: 'IsSuitIMSByCus',
		title: "经销商范围适用于IMS：",
		inputtype: "checkedD",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 0,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 500,
		checked: false,
		hidden: false,
	}, {
		key: 'OOrganization',
		modelvalue: undefined,
		title: "出库方：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 170,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	}, {
		key: 'SalesModel',
		modelvalue: undefined,
		title: "销售模式：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 80,
		marginTop: 25,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		hidden: true,
	}
];
export default FromArrEditor;

/*,
	{
		key: 'valiDate',
		title: "启效日期：",
		inputtype: "date",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		placeholder: "请输入",
		width: 222,
		height: 32,
		disabled: false,
		marginLeft: 114,
		marginTop: 22,
		displayVal: "inline-block",
		fontWeightVal: 500
	}**/